import { FunctionComponent } from 'react'
import { LinkList } from '../types'
import { useBreakpoints } from '../../../../hooks/useBreakpoints'
import DesktopLinkLists from '../desktop/link-lists'
import MobileLinkLists from '../mobile/link-lists'

const ResponsiveLinkList: FunctionComponent<{ linkLists: LinkList[] }> = ({ linkLists }) => {
  const { isTabletOrLess } = useBreakpoints()
  return isTabletOrLess ? <MobileLinkLists linkLists={linkLists} /> : <DesktopLinkLists linkLists={linkLists} />
}

export default ResponsiveLinkList
